import { usePermissions } from '@klareospace/pharos-lib-front-utils';

// ─── Constants ──────────────────────────────────────────────────────────────

const KPIS_READ_PERMISSION = 'kpis:read';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** True when the user holds `kpis:read`. */
export function useIsKpiReadEnabled(): boolean {
  const { hasPermission } = usePermissions();
  return hasPermission(KPIS_READ_PERMISSION);
}
